import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { environment } from '../../../../../environments/environment';
import { CommonService } from '../../common-service';
import { ValidarContasPagarImportacaoRequest } from '../../requests/financas/importacao/validar-contas-pagar-importacao.request';
import { ValidarContasPagarImportacaoResponse } from '../../responses/financas/importacao/validar-contas-pagar-importacao.response';
import { ReturnStruct } from '../../structs/return.struct';
import { ItemValidacaoContasPagarStruct } from '../../structs/financas/importacao/item-validacao-contas-pagar.struct';
import { ConfirmarContasPagarImportacaoRequest } from '../../requests/financas/importacao/confirmar-contas-pagar-importacao.request';

@Injectable({
  providedIn: 'root'
})
export class ImportarContasPagarService extends CommonService {
  private apiUrl: string = environment.urlApiOrquestradorFinancas + 'ImportarContasPagar';

  constructor(private httpClient: HttpClient) {
    super();
  }

  public validar(request: ValidarContasPagarImportacaoRequest): Observable<ValidarContasPagarImportacaoResponse> {
    return this.httpClient
      .post<ValidarContasPagarImportacaoResponse>(
        `${this.apiUrl}/validar`,
        request,
        this.addHeaderToken()
      )
      .pipe(catchError(this.handleError.bind(this)));
  }

  public confirmar(request: ConfirmarContasPagarImportacaoRequest): Observable<ReturnStruct> {
    return this.httpClient
      .post<ReturnStruct>(`${this.apiUrl}/confirmar`, request, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }
}
